import * as React from 'react'

import type { $Keys } from 'utility-types'

import styles from 'modules/core/components/BrowserBarPreview/index.module.scss'

import DefaultBrowser from './_DefaultBrowser'
import ExtraBigBrowser from './_ExtraBigBrowser'
import LinkedinBrowser from './_LinkedinBrowser'
import RealFavicon from './_RealFavicon'

export const SIZES = {
  normal: 'normal',
  big: 'big',
  extraBig: 'extraBig',
} as const

const WIDTH: Record<string, number> = {
  normal: 320,
  big: 400,
  extraBig: 533,
}

export const SITES: Record<string, string> = {
  linkedin: 'linkedin',
  complaints: 'complaints',
}

export type SizeType = $Keys<typeof SIZES>

export type SiteType = $Keys<typeof SITES>
interface BrowserProps {
  hasRealFavicon: boolean
  site?: SiteType
  size?: SizeType
}

const Browser = ({ hasRealFavicon, size, site }: BrowserProps) => {
  if (site === SITES.linkedin) {
    return <LinkedinBrowser />
  }

  if (size === SIZES.extraBig) {
    return <ExtraBigBrowser hasRealFavicon={hasRealFavicon} />
  }

  return <DefaultBrowser hasRealFavicon={hasRealFavicon} />
}

interface BrowserImageProps {
  faviconImage?: any
  size?: SizeType
  site?: SiteType
}

const BrowserImage = ({ faviconImage, site, size = SIZES.normal as any }: BrowserImageProps) => {
  const width = WIDTH[size]
  const viewBox = size === SIZES.extraBig ? `0 0 ${width} 98` : '0 0 320 79'
  const hasRealFavicon = !!faviconImage

  return (
    <div className={styles.browserImage}>
      {hasRealFavicon && <RealFavicon faviconImage={faviconImage} />}
      <svg width={width} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
        <Browser size={size} site={site} hasRealFavicon={hasRealFavicon} />
      </svg>
    </div>
  )
}

export default BrowserImage
